
const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'


const TokenService = {

    getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY)
    },

    setAccessToken(accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    },

    removeAccessToken() {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
    },

    hasAccessToken() {
        return !!this.getAccessToken()
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    setRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },

    hasRefreshToken() {
        return !!this.getRefreshToken()
    },

    getClaims() {
        let token = this.getAccessToken()
        let claims = {}

        if (token) {

            try {

                let [, encodedPayload] = token.split('.')
                let buffer = new Buffer(encodedPayload, 'base64')
                claims = JSON.parse(buffer.toString('utf-8'))

            } catch(err) {
                claims = {}
            }
            
        }
        return claims
    },

    getClaim(claim, defaultValue = null) {
        let claims = this.getClaims()

        return claims[claim] || defaultValue
    },

}

export default TokenService
